<template>
  <div class="header-section headerBox">
    <div class="system">安康市涉农信用信息平台</div>
    <div class="menu">
      <el-menu
        :default-active="activeIndex"
        background-color="transparent"
        text-color="#c5c3c3"
        active-text-color="#fff"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item
          v-for="item in navigateList"
          :key="item.path"
          :index="item.path"
          @click="goTo(item.path)"
          >{{ item.name }}</el-menu-item
        >
      </el-menu>
    </div>
    <div class="user-info">
      <MessageBell />
      <el-dropdown trigger="click" size="small" @command="handleCommand">
        <div class="el-dropdown-link">
          <img src="@/images/avatar.svg" class="icon-user" alt />
          <span class="user">欢迎登录！{{ username }}</span>
          <i class="icon-arrow el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="modifyPwd"
            ><span>修改密码</span></el-dropdown-item
          >
          <el-dropdown-item command="logout"
            ><span>退出登录</span></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>


    <el-dialog
      :title="modifyPwdDialog.title"
      :visible.sync="modifyPwdDialog.visible"
      :before-close="closeModifyPwdDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      width="530px"
      :append-to-body="true"
      top="10vh"
    >
      <div>
        <el-form
          ref="modifyPwdForm"
          class="modifyPwd-form"
          autocomplete="off"
          :model="modifyPwdDialog"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item prop="oldPassword" label="原密码">
            <el-input
              v-model="modifyPwdDialog.oldPassword"
              type="password"
              placeholder="原密码"
              :autofocus="true"
            />
          </el-form-item>
          <el-form-item prop="newPassword" label="新密码">
            <el-input
              v-model="modifyPwdDialog.newPassword"
              type="password"
              placeholder="新密码"
            />
          </el-form-item>
          <el-form-item prop="confirmPassword" label="确认密码">
            <el-input
              v-model="modifyPwdDialog.confirmPassword"
              type="password"
              placeholder="确认密码"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModifyPwdDialog">取 消</el-button>
        <el-button type="primary" @click="submitModifyPwd">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { logOut, modifyPwd } from "@/api/index";
import { validatePwd, validateForm } from "@/utils";
import { rsaEncrypt } from "@/utils/jsencrypt";
import MessageBell from "@/components/MessageBell.vue";
export default {
  components: {
    MessageBell
  },
  data() {
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.modifyPwdDialog.newPassword) {
        callback(new Error("确认密码和新密码不一致。"));
      } else {
        callback();
      }
    };
    return {
      activeIndex: '',
      username: this.$store.state.system.userInfoweb.username,
      type: this.$store.state.system.userInfoweb.type,
      timer: null,
      timer2: null,
      modifyPwdDialog: {
        title: "修改密码",
        visible: false,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: "请输入原密码",
            trigger: ["blur", "change"],
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: ["blur", "change"],
          },
          { validator: validatePwd },
        ],
        confirmPassword: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: ["blur", "change"],
          },
          {
            validator: validateConfirmPwd,
            trigger: ["blur", "change"],
          },
        ],
      },
      navigateList: [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "政策解读",
          path: "/news",
        },
        {
          name: "融资服务",
          path: "/products",
        },
        {
          name: "融资需求",
          path: "/needs",
        },
        {
          name: "信用服务",
          path: "/service",
        },
        {
          name: "机构信息",
          path: "/organ",
        },
        {
          name: "平台介绍",
          path: "/aboutUs",
        },
      ],
    };
  },

  computed: {},
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  created() {
  },
  methods: {
    goTo(url){
      this.$router.push(url);
    },
    handleCommand(command) {
      command === "logout" && this.logout();
      command === "modifyPwd" && this.modifyPwd();
    },
    handleCommand (command) {
      command === "logout" && this.logout();
      command === "modifyPwd" && this.modifyPwd();
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$store.dispatch("setRouterName", key);
    },
    logout() {
      this.$confirm(`确认退出登录？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((_) => {
        logOut().then((res) => {
          window.localStorage.removeItem('tokenweb');
          window.localStorage.removeItem('userInfoweb');
          this.$router.replace('/home')
        });
      });
    },
    modifyPwd() {
      this.modifyPwdDialog.visible = true;
    },

    submitModifyPwd () {
      if (!validateForm(this.$refs["modifyPwdForm"])) {
        message = "表单信息缺失。";
        this.$baseMessage(message, "error");
        return;
      }
      const params = {
        oldPassword: rsaEncrypt(this.modifyPwdDialog.oldPassword),
        newPassword: rsaEncrypt(this.modifyPwdDialog.newPassword),
      };
      modifyPwd(params).then((res) => {
        this.$baseMessage("修改密码成功，请重新登录。", "success");
        this.closeModifyPwdDialog();
        this.$store.dispatch("logout");
        let type = 2;
        if(this.type == 4){
          type = 1;
        }
        this.$router.push({
          name: 'login' ,
          query:{
              type : type
            }
        })
      });
    },
    closeModifyPwdDialog() {
      this.modifyPwdDialog.visible = false;
      this.modifyPwdDialog.newPassword = "";
      this.modifyPwdDialog.confirmPassword = "";
    },
  },
};
</script>

<style scoped lang="scss">
.headerBox {
  width: 100%;
  padding: 0 15%;
  background-color: #fff;
  z-index: 888;
}
.header-section {
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  .system {
    font-size: 28px;
    margin-left: 25px;
  }

  .menu {
    ::v-deep .el-menu li:hover {
      background: #fafafa!important;
    }
    ::v-deep .el-menu .is-active {
      border-bottom: none !important;
    }


    ::v-deep .el-menu-item {
      font-size: 16px;
      color: #333!important;
    }
  }
  ::v-deep .el-menu.el-menu--horizontal{
     border-bottom: none !important;
  }
  .user-info {
    margin-right: 30px;
    /* color: #fff; */
    cursor: pointer;
    .icon-user {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      vertical-align: middle;
    }
    .user {
      margin-left: 5px;
      margin-right: 5px;
      vertical-align: middle;
      /* color: #fff; */
    }
    .icon-arrow {
      vertical-align: middle;
      color: #fff;
    }
  }
}
</style>
